var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message",class:{ 'is-cold': _vm.isCold }},[_c('p',[_vm._v(_vm._s(_vm.getMessage()))])])}
var staticRenderFns = []

export { render, staticRenderFns }